import { DataValidator, IsBoolean, IsNumber, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api from "./api";

interface UserAudioTemplateAddResponse {
  message: string;
  count: number
}

export interface UserAudioTemplateAddRequest {
  agentId: string,
  userAudioTemplateId: string
}

export class UserAudioTemplateAddData {
  id?: number;
}

const transformAndValidateData = (
  response: UserAudioTemplateAddResponse
): UserAudioTemplateAddData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, UserAudioTemplateAddData);
  } catch (error) {
    console.error("userAudioTemplateAdd data validation failed:", error.message);
    throw error;
  }
};

// 保存智能体用户音频（播客音频-用户端）
export const userAudioTemplateAdd = async (templates: UserAudioTemplateAddRequest[]) => {
  const res = await api.post<UserAudioTemplateAddResponse>('/user_audio_template/add', {
    templates: templates.map(item => ({
      agent_id: item.agentId,
      user_audio_template_id: item.userAudioTemplateId,
    })),
  });
  return transformAndValidateData(res.data);
};
